module.exports = __webpack_public_path__ + "img/t2.de42cd46.svg";